/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForMonthlyCostReport extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForMonthlyCostReport");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForMonthlyCostReport.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForMonthlyCostReport>): BackgroundJobPayloadForMonthlyCostReport {
        let obj = Object.assign(new BackgroundJobPayloadForMonthlyCostReport(), model);
        BackgroundJobPayloadForMonthlyCostReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForMonthlyCostReport>): BackgroundJobPayloadForMonthlyCostReport {
        if (!model) return null;
        return BackgroundJobPayloadForMonthlyCostReport.newInstance(<BackgroundJobPayloadForMonthlyCostReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForMonthlyCostReport) {
        if (!obj) return;

        models.BackgroundJobPayloadForMonthlyCostReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForMonthlyCostReport): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForMonthlyCostReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

}
